const config = {
  isProd: process.env.NODE_ENV === "production",
  apiBase: process.env.REACT_APP_API_ENDPOINT,
  resourceBase: process.env.REACT_APP_RESOURCE_BASEURL,
  cmsEndpoint: process.env.REACT_APP_CMS_ENDPOINT,
  ver: process.env.REACT_APP_VERSION,
  updateDate: process.env.REACT_APP_UPDATED_AT,
  MultiTxaCode : process.env.REACT_APP_MULTITXACODE,
}

console.log(process.env, config)
export default {
  ...config
}